{
  "title": "Poison Spray",
  "source": "Player's Handbook",
  "levelAndSchool": "Conjuration cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "10 feet",
  "components": "V, S",
  "duration": "Instantaneous",
  "description": [
    "You extend your hand toward a creature you can see within range and project a puff of noxious gas from your palm. The creature must succeed on a Constitution saving throw or take 1d12 poison damage.",
    "At Higher Levels. This spell’s damage increases by 1d12 when you reach 5th level (2d12), 11th level (3d12), and 17th level (4d12)."
  ],
  "spellLists": [
    "artificer",
    "druid",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "warlock",
    "wizard"
  ]
}
